module.exports = __webpack_public_path__ + "media/images/city/061-clock-tower-4952924fe0893080212a47ad2ab865cf.svg";